import React from "react";
import classnames from "classnames";
import s from "./PrettyDateBox.module.scss";
const PrettyDateBoxStatic = ({ text, visible = false }) => (React.createElement("div", { className: classnames(s.timestampBoxContainer, s.fixedDate, {
        [s.visible]: visible,
    }) },
    React.createElement("div", { className: s.timestampBox },
        React.createElement("p", { className: s.timeDiffText }, text))));
export default PrettyDateBoxStatic;
